import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol, PageFeatureConfigSymbol, Fetch } from '@wix/thunderbolt-symbols'
import type { IFetchApi } from '@wix/thunderbolt-symbols'
import { ESMLoaderFactorySymbol } from 'feature-builder-module-loader'
import type { ESMLoaderFactory } from 'feature-builder-module-loader'
import type { ScriptCache } from '@wix/thunderbolt-renderer-utils'
import type { BuilderContextProvidersSiteConfig, BuilderContextProvidersPageConfig, ContextProviderLoader, ContextProviderRegistry } from './types'
import { ContextProviderRegistrySymbol, name } from './symbols'
export const BuilderContextProvidersLoader = withDependencies(
	[named(SiteFeatureConfigSymbol, name), named(PageFeatureConfigSymbol, name), ESMLoaderFactorySymbol, Fetch, ContextProviderRegistrySymbol],
	(siteFeatureConfig: BuilderContextProvidersSiteConfig, pageFeatureConfig: BuilderContextProvidersPageConfig, esmLoaderFactory: ESMLoaderFactory, fetchApi: IFetchApi, contextProviderRegistry: ContextProviderRegistry): ContextProviderLoader => {
		const scriptsCache: ScriptCache = {}
		const moduleLoader = esmLoaderFactory({
			scriptsCache,
			fetch: fetchApi.envFetch,
			globalThis,
		})

		return {
			retrieveContextProviders: async (compId: string) => {
				const contexts = pageFeatureConfig.compIdToContextsMap[compId] || []
				await Promise.all(
					contexts.map(async (context) => {
						const { contextType } = context
						const contextProviderData = siteFeatureConfig.contextProviders[contextType]
						const urlToLoad = process.env.PACKAGE_NAME === 'thunderbolt-ds'
							? contextProviderData.editorComponentUrl || contextProviderData.componentUrl
							: contextProviderData.componentUrl

						const contextProviderModule = await moduleLoader.loadModule(urlToLoad)
						contextProviderRegistry.registerContextProvider(contextType, contextProviderModule)
					})
				)
			}
		}
	}
)
